import { render, staticRenderFns } from "./ChartAccounts.vue?vue&type=template&id=8150ebd8&scoped=true"
import script from "./ChartAccounts.vue?vue&type=script&lang=js"
export * from "./ChartAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8150ebd8",
  null
  
)

export default component.exports